import { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";

export default function Contact() {
  const [showSuccess, setShowSuccess] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const formRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (showSuccess) {
      // Success message show hone par top par scroll karo
      window.scrollTo({ top: 0, behavior: "smooth" });
      
      // 5 seconds ke baad home page par redirect
      const timer = setTimeout(() => {
        navigate('/');
      }, 5000);
      
      return () => clearTimeout(timer);
    }
  }, [showSuccess, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    const form = e.target;
    const formData = new FormData(form);

    try {
      // FormSubmit ko data bhejo
      await fetch(form.action, {
        method: 'POST',
        body: formData,
        headers: {
          'Accept': 'application/json'
        }
      });

      // Success message dikhaao
      setShowSuccess(true);
      
      // Form ko reset karo
      form.reset();
      
    } catch (error) {
      console.error('Error:', error);
      alert('Something went wrong. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-[linear-gradient(135deg,#05001a,#0a0133,#140145)] text-white p-6 pt-24">
      {/* Text for Contact Us */}
      <div className="flex justify-center mb-10 lg:mb-10">
        <div className="max-w-5xl">
          <div className="flex justify-center text-4xl font-bold pb-6 lg:pb-6">
            Contact Us – Cybredge Pvt Ltd
          </div>
          <p className="text-xl">
            Connect with us for internship details, support, or career guidance.
            We're excited to hear from you.
          </p>
        </div>
      </div>

      <div
        className="max-w-4xl mx-auto backdrop-blur-lg bg-white/10 border border-white/20 rounded-3xl p-5 shadow-xl"
        data-aos="fade-up"
        data-aos-delay="100"
      >
        <h1 className="text-5xl font-bold mb-6">Contact Us</h1>

        {/* Success Message */}
        {showSuccess && (
          <div className="mb-6 p-8 bg-green-500/20 border border-green-400/50 rounded-2xl backdrop-blur-xl">
            <div className="flex items-start justify-between">
              <div className="flex items-start gap-4">
                <div className="w-16 h-16 bg-green-500/30 rounded-full flex items-center justify-center flex-shrink-0 animate-bounce">
                  <svg
                    className="w-10 h-10 text-green-400"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                    />
                  </svg>
                </div>
                <div>
                  <h3 className="text-3xl font-bold text-green-400 mb-3">
                    Message Sent Successfully! ✓
                  </h3>
                  <p className="text-white/90 text-lg mb-2">
                    Thank you for contacting Cybredge Pvt Ltd.
                  </p>
                  <p className="text-white/80 mb-4">
                    We've received your message and will get back to you within 24-48 hours.
                  </p>
                  <div className="bg-white/10 border border-white/20 rounded-xl p-4 mt-4">
                    <p className="text-white/90">
                      Redirecting to home page in <span className="text-green-400 font-bold">5 seconds</span>...
                    </p>
                    <button
                      onClick={() => navigate('/')}
                      className="mt-3 px-6 py-2 bg-white text-cyan-700 font-bold rounded-lg shadow-lg hover:bg-white/90 transition-all duration-300 hover:scale-105"
                    >
                      Go to Home Now
                    </button>
                  </div>
                </div>
              </div>
              <button
                onClick={() => setShowSuccess(false)}
                className="text-white/60 hover:text-white text-3xl transition-colors leading-none"
                aria-label="Close"
              >
                ×
              </button>
            </div>
          </div>
        )}

        <form
          ref={formRef}
          action="https://formsubmit.co/cybredgeprivatelimited@gmail.com"
          method="POST"
          className="flex flex-col gap-6"
          data-aos="fade-up"
          data-aos-delay="100"
          onSubmit={handleSubmit}
        >
          {/* Required Hidden Inputs */}
          <input type="hidden" name="_captcha" value="false" />
          <input type="hidden" name="_template" value="box" />
          <input
            type="hidden"
            name="_subject"
            value="New Contact Form Message from Cybredge Website!"
          />

          <input
            className="p-4 rounded-xl bg-white/20 backdrop-blur-xl border border-white/30 text-white placeholder-white/70 focus:outline-none focus:ring-2 focus:ring-white/50 transition-all"
            placeholder="Full Name"
            name="name"
            type="text"
            required
            disabled={isSubmitting}
          />

          <input
            className="p-4 rounded-xl bg-white/20 backdrop-blur-xl border border-white/30 text-white placeholder-white/70 focus:outline-none focus:ring-2 focus:ring-white/50 transition-all"
            placeholder="Email Address"
            type="email"
            name="email"
            required
            disabled={isSubmitting}
          />

          <input
            className="p-4 rounded-xl bg-white/20 backdrop-blur-xl border border-white/30 text-white placeholder-white/70 focus:outline-none focus:ring-2 focus:ring-white/50 transition-all"
            placeholder="Mobile Number"
            type="tel"
            name="phone"
            pattern="[0-9]{10}"
            maxLength="10"
            required
            disabled={isSubmitting}
          />

          <textarea
            className="p-4 h-32 rounded-xl bg-white/20 backdrop-blur-xl border border-white/30 text-white placeholder-white/70 resize-none focus:outline-none focus:ring-2 focus:ring-white/50 transition-all"
            placeholder="Your Message"
            name="message"
            required
            disabled={isSubmitting}
          ></textarea>

          <button
            type="submit"
            disabled={isSubmitting}
            className="px-8 py-3 bg-white text-cyan-700 font-bold rounded-xl shadow-lg hover:bg-white/90 transition-all duration-300 hover:scale-105 active:scale-95 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {isSubmitting ? (
              <span className="flex items-center justify-center gap-2">
                <svg className="animate-spin h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
                Sending...
              </span>
            ) : (
              "Send Message"
            )}
          </button>
        </form>
      </div>
    </div>
  );
}